import { render } from "./MyNavbar.vue?vue&type=template&id=5587c238"
import script from "./MyNavbar.vue?vue&type=script&lang=js"
export * from "./MyNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__